export enum TOOLBAR_BUTTONS {
  UploadFile = 'UploadFile',
  UploadImage = 'UploadImage',
  Link = 'Link',
  Undo = 'Undo',
  Redo = 'Redo',
  Size = 'Size',
  FontSize = 'FontSize',
  Bold = 'Bold',
  Italic = 'Italic',
  Underline = 'Underline',
  Align = 'Align',
  Strikethrough = 'Strikethrough',
  Color = 'Color',
  BackgroundColor = 'BackgroundColor',
  BulletedList = 'BulletedList',
  NumberedList = 'NumberedList',
  BlockQuote = 'BlockQuote',
  CodeBlock = 'CodeBlock',
  LinkButton = 'LinkButton',
  Separator = 'Separator',
  HorizontalRule = 'HorizontalRule',
  IFrame = 'IFrame',
  Video = 'Video',
  Action = 'Action',
  ColumnOptions = 'ColumnOptions',
  Table = 'Table',
  ExpandBlock = 'ExpandBlock',
  Increase = 'Increase',
  Decrease = 'Decrease',
  Superscript = 'Superscript',
  Subscript = 'Subscript',
}

export interface IToolbarButtonView {
  [TOOLBAR_BUTTONS.UploadFile]: boolean
  [TOOLBAR_BUTTONS.UploadImage]: boolean
  [TOOLBAR_BUTTONS.Link]: boolean
  [TOOLBAR_BUTTONS.Undo]: boolean
  [TOOLBAR_BUTTONS.Redo]: boolean
  [TOOLBAR_BUTTONS.Size]: boolean
  [TOOLBAR_BUTTONS.FontSize]: boolean
  [TOOLBAR_BUTTONS.Bold]: boolean
  [TOOLBAR_BUTTONS.Italic]: boolean
  [TOOLBAR_BUTTONS.Underline]: boolean
  [TOOLBAR_BUTTONS.Strikethrough]: boolean
  [TOOLBAR_BUTTONS.Color]: boolean
  [TOOLBAR_BUTTONS.BackgroundColor]: boolean
  [TOOLBAR_BUTTONS.Align]: boolean
  [TOOLBAR_BUTTONS.BulletedList]: boolean
  [TOOLBAR_BUTTONS.NumberedList]: boolean
  [TOOLBAR_BUTTONS.BlockQuote]: boolean
  [TOOLBAR_BUTTONS.CodeBlock]: boolean
  [TOOLBAR_BUTTONS.LinkButton]: boolean
  [TOOLBAR_BUTTONS.Separator]: boolean
  [TOOLBAR_BUTTONS.HorizontalRule]: boolean
  [TOOLBAR_BUTTONS.IFrame]: boolean
  [TOOLBAR_BUTTONS.Action]: boolean
  [TOOLBAR_BUTTONS.Video]: boolean
  [TOOLBAR_BUTTONS.ColumnOptions]: boolean
  [TOOLBAR_BUTTONS.Table]: boolean
  [TOOLBAR_BUTTONS.ExpandBlock]: boolean
  [TOOLBAR_BUTTONS.Increase]: boolean
  [TOOLBAR_BUTTONS.Decrease]: boolean
  [TOOLBAR_BUTTONS.Superscript]: boolean
  [TOOLBAR_BUTTONS.Subscript]: boolean
}
